/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import Box from "@mui/material/Box";
import React from "react";

export interface TabPanelProps {
    children?: JSX.Element | JSX.Element[];
    selected: boolean;
    index: number;
    other?: any;
}

export const TabPanel = (props: TabPanelProps) => {
    const { children, selected, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={!selected}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {selected && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
};
